export const opomena_pred_otkaz = {
  templateId: 12,
  category: 1,
  templateTitle: "Upozorenje na mogućnost otkaza ugovora o radu uslijed skrivljenog ponašanja radnika (opomena pred otkaz)",
  templateDescription: `U slučaju povrede obveze iz radnog odnosa od strane radnika, poslodavac može radnika upozoriti na obveze iz radnog odnosa i ukazati mu na mogućnost otkaza u slučaju nastavka povrede te obveze. No, takva obavijest ujedno je i preduvjet zakonske usklađenosti redovitog otkaza uvjetovanog ponašanjem radnika.`,
  description: `
    <h5>OPIS DOKUMENTA</h5>
    <p><strong>Prije redovitog otkazivanja uvjetovanog skrivljenim ponašanjem radnika, poslodavac je dužan radnika pisano upozoriti na obveze iz radnog odnosa i ukazati mu na mogućnost otkaza u slučaju nastavka povrede te obveze, osim ako postoje okolnosti zbog kojih nije opravdano očekivati od poslodavca da to učini.</strong></p>
    <p>Poslodavac takvo upozorenje (opomena pred otkaz), može dati i višekratno, za iste ili različite povrede iz radnog odnosa.</p>
    <p>Zakon o radu ne propisuje što se smatra kršenjem obveze iz radnog odnosa, ali određuje koja ponašanja nisu opravdani razlog za otkaz uslijed skrivljenog ponašanja radnika - privremena nenazočnost zbog bolesti ili ozljede, podnošenje tužbe ili žalbe, organiziranje i sudjelovanje u štrajku i sl.. </p>
    <p><strong>Ovaj tekst i primjerak upozorenja u nastavku teksta se odnosi na situacije opomena pred otkaz u kojima poslodavac nije usvojio pravilnik o radu, stoga razlog upozorenja mora proizlaziti isključivo iz odradaba Zakona o radu. </strong></p>
    <p>Zakon o radu ne predviđa rok od nastanka događaja kojim je radnik prekršio radne obveze do trenutka izricanja pisanog upozorenja na mogućnost otkaza. </p>
    <p>Povredu radne obveze (u ovom slučaju blažu) zbog koje se može uputiti upozorenje na obveze iz radnog odnosa treba razlikovati od osobito teške povrede iz radnog odnosa uslijed koje se može radniku dati izvanredni otkaz. </p>
    <p>Zakon ne propisuje niti povrede obveza iz radnog odnosa na temelju kojih poslodavac može dati upozorenja radniku, niti osobito teške povrede obveza iz radnog odnosa (uslijed kojih se može radniku dati izvanredni otkaz), nego se iste procjenjuju od slučaja do slučaja. </p>
    <p><strong>Osim toga, bitno je naglasiti da je eventualni otkaz ugovora o radu koji bi mogao uslijediti nakon pisanog upozorenja zakonski je dopušteno dati radniku isključivo radi povrede baš te radne obveze na koju je radnik pisano upozoren. </strong></p>
    <h5>SVRHA DOKUMENTA</h5>
    <p>Svrha dokumenta je upozorenje radniku na obveze iz radnog otkaza te ispunjenje zakonske pretpostavke za mogućnost otkaza zbog skrivljenog ponašanja radnika. </p>
    <p>Upozorenjem se otklanjaju i eventualni nesporazumi o obvezama radnika iz radnog odnosa, a koji bi mogli proizaći iz nedovoljno uređenih odredbi Zakona o radu, ugovora o radu odnosno internih akata poslodavca. </p>
    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- Upozorenje na mogućnost otkaza je dana usmeno</strong></p>
    <p>Pojašnjenje:  pisani oblik je zakonska obveza, stoga će u slučaju usmenog upozorenja eventualni otkaz biti nezakonit. </p>
    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o radu.</p>
  `,

  sides: [
    {
      prefix: "Na temelju Zakona o radu,",
      signature: "Za Poslodavca:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      suffix: " (u daljnjem tekstu: Poslodavac),",
    }
  ],

  headline: "upućuje sljedeće",
  title: "UPOZORENJE NA OBVEZE IZ RADNOG ODNOSA U SVEZI MOGUĆNOSTI OTKAZA UGOVORA O RADU",

  noArticleNumbers: true,
  noArticleTitle: true,

  articles: [
    {
      mandatory: true,
      statements: [
          {
              title: '',
              type: 'input',
              mandatory: true,
              editable: true,
              parts: [
                  { type: 'text', content: 'Radnik' },
                  { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                  { type: "text", content: "," },
                  { type: 'text', content: 'iz',},
                  { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                  { type: 'text', content: ',' },
                  { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                  { type: "text", content: "," },
                  { type: 'text', content: 'OIB:' },
                  { type: "input",  required: true,},
                  { type: 'text', content: ',' },
                  { type: 'text', content: 'zaposlen na radnom mjestu' },
                  { type: 'input', value: '', required: true },
                  { type: 'text', content: '(u nastavku teksta: Radnik), upozorava se na obveze iz radnog odnosa u svezi mogućnosti otkaza ugovora o radu. ' },
              ],
              value: '',
          },
      ],
  },
    {
      title: "",
      mandatory: true,
      exampleContent: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "Dana ____________ godine, gore imenovani Radnik počinio je povredu obveza i radnog odnosa time što je prilikom ugovaranja komercijalnih uvjeta s poslovnim partnerom __________, zaključio komercijalni odnos kupoprodaje pod uvjetima koji nisu prethodno potvrđeni od strane nadređene osobe  – voditelja odjela prodaje.",
          help: "Za svako upozorenje potrebno je posebno obrazložiti točno određenu povredu radne obveze koje mogu biti različite s obzirom na specifičnost djelatnosti i organizacije posla poslodavca."
        }]
    },
    {
      title: "",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "Takvom povredom narušen je odnos povjerenja Poslodavca i Radnika."
        }]
    },
    {
      title: "",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "Iz tog razloga, u slučaju nastavka kršenja obveza iz radnog odnosa, Poslodavac upozorava Radnika na mogućnost otkaza ugovora o radu zbog skrivljenog ponašanja Radnika."
        }]
    },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true,
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures
      statements: [],
    },
    {
      static: true,
      mandatory: false,
      type: 4, 
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska služba',
          help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
        }
      ]
    },
    {
      static: true,
      mandatory: true,
      type: 4, 
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          help: 'Ako postupak dostave nije uređen kol. ug., sporazumom između radničkog vijeća i poslodavca ili pravilnikom o radu, primjenjuju se odredbe o dostavi određene parničnim postupkom. U tom slučaju, otkaz se može dostaviti prep. pošt. pošiljkom s povr. ili osobno, na radnom mjestu, no ukoliko radnik odbija primiti odluku, navedeno odbijanje može se pisano konstatirati uz potpis dva svjedoka. Otkaz se može dostaviti i putem j. bilježnika.',
          content: 'Potvrđujem primitak Odluke dana _______________ godine.\r\n\r\nPotpis Radnika: ____________________\r\n\r\n',
        },
      ]
    },
  ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/12_opomena_pred_otkaz.ts